import { Dropdown as DsDropdown } from '@digdir/designsystemet-react'

export const DropdownAction = DsDropdown.Button
